// Mobile navigation toggle
(function () {
  var toggle = document.querySelector('[data-menu-toggle]');
  var nav = document.querySelector('[data-site-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
})();

// Header shadow once the page is scrolled
(function () {
  var header = document.querySelector('.site-header');
  if (!header) return;
  function update() {
    header.classList.toggle('is-scrolled', window.scrollY > 8);
  }
  window.addEventListener('scroll', update, { passive: true });
  update();
})();

// Scroll progress bar (visual enhancement only)
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var bar = document.createElement('div');
  bar.className = 'scroll-progress';
  bar.setAttribute('aria-hidden', 'true');
  document.body.appendChild(bar);
  function update() {
    var doc = document.documentElement;
    var max = doc.scrollHeight - doc.clientHeight;
    bar.style.width = (max > 0 ? (doc.scrollTop / max) * 100 : 0) + '%';
  }
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update, { passive: true });
  update();
})();

// Parallax drift for decorative ghost words ([data-parallax="speed"]).
// Purely ornamental: elements are always visible, transform only, and
// disabled entirely under prefers-reduced-motion.
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var els = Array.prototype.slice.call(document.querySelectorAll('[data-parallax]'));
  if (!els.length) return;
  var pending = false;

  function update() {
    pending = false;
    var vh = window.innerHeight;
    els.forEach(function (el) {
      var rect = el.parentElement.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > vh) return;
      var speed = parseFloat(el.getAttribute('data-parallax')) || 0.12;
      var offset = (rect.top + rect.height / 2 - vh / 2) * speed;
      el.style.transform = 'translateY(' + offset.toFixed(1) + 'px)';
    });
  }

  function schedule() {
    if (!pending) {
      pending = true;
      window.requestAnimationFrame(update);
    }
  }

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  update();
})();

// Infinite catalog. The grid marks itself with [data-infinite-grid] and the
// "Load more" wrapper with [data-infinite-next]; its inner <a> points at the
// next paginated page, so with no JavaScript it is an ordinary pager link.
// With JavaScript we fetch that page, append its cards, and repeat as the
// visitor approaches the bottom — one continuous page, no page changes.
(function () {
  var grid = document.querySelector('[data-infinite-grid]');
  var wrap = document.querySelector('[data-infinite-next]');
  if (!grid || !wrap) return;
  var link = wrap.querySelector('a');
  if (!link) return;
  var label = link.textContent;
  var loading = false;

  function finish() {
    wrap.parentNode && wrap.parentNode.removeChild(wrap);
    link = null;
    window.removeEventListener('scroll', check);
  }

  function load() {
    if (loading || !link) return;
    var url = link.getAttribute('href');
    if (!url) { finish(); return; }
    loading = true;
    wrap.classList.add('is-loading');
    link.textContent = 'Loading…';
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('[data-infinite-grid]');
        var newLink = doc.querySelector('[data-infinite-next] a');
        if (newGrid) {
          Array.prototype.slice.call(newGrid.children).forEach(function (child) {
            grid.appendChild(child);
          });
        }
        loading = false;
        wrap.classList.remove('is-loading');
        if (newLink && newLink.getAttribute('href')) {
          link.setAttribute('href', newLink.getAttribute('href'));
          link.textContent = label;
          check();
        } else {
          finish();
        }
      })
      .catch(function () {
        // Leave the button as a working link to the next page
        loading = false;
        wrap.classList.remove('is-loading');
        if (link) link.textContent = label;
      });
  }

  link.addEventListener('click', function (e) {
    e.preventDefault();
    load();
  });

  function check() {
    if (!link || loading) return;
    var rect = wrap.getBoundingClientRect();
    if (rect.top < window.innerHeight + 500) load();
  }

  window.addEventListener('scroll', check, { passive: true });
  check();
})();

// Scroll reveal — progressive enhancement only.
// Elements are visible by default; CSS nudges them 16px down only when
// <html> has the "js" class, and this script releases them based on
// scroll position. Sibling reveals get a small stagger via --reveal-delay.
(function () {
  var items = Array.prototype.slice.call(document.querySelectorAll('.reveal'));
  if (!items.length) return;

  // Assign stagger delays per parent group
  var groups = new Map();
  items.forEach(function (el) {
    var parent = el.parentElement;
    var index = groups.get(parent) || 0;
    groups.set(parent, index + 1);
    el.style.setProperty('--reveal-delay', Math.min(index, 5) * 70 + 'ms');
  });

  var pending = false;

  function inView(el) {
    var rect = el.getBoundingClientRect();
    return rect.top < window.innerHeight * 0.92 && rect.bottom > 0;
  }

  // After the entrance animation has had time to play, settle the element
  // into its final resting state via the .is-settled class (animation: none;
  // transform: none in CSS). Class-based rather than inline styles so hover
  // transforms still work afterwards; if the entrance animation ever stalls,
  // this still guarantees correct final layout.
  function pin(el) {
    el.classList.add('is-settled');
    // Cancel any transform transition/animation that stalled mid-flight —
    // in a frozen-rendering environment it would otherwise hold the offset.
    if (el.getAnimations) {
      el.getAnimations().forEach(function (a) {
        var prop = a.transitionProperty || a.animationName;
        if (prop === 'transform' || prop === 'rise-in') a.cancel();
      });
    }
  }

  function settle(el) {
    var delay = parseInt(el.style.getPropertyValue('--reveal-delay'), 10) || 0;
    setTimeout(function () { pin(el); }, 700 + delay);
  }

  function check() {
    pending = false;
    items = items.filter(function (el) {
      if (inView(el)) {
        el.classList.add('is-visible');
        settle(el);
        return false;
      }
      return true;
    });
    if (!items.length) {
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
    }
  }

  function schedule() {
    if (!pending) {
      pending = true;
      window.requestAnimationFrame(check);
    }
  }

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  check();

  // Absolute safety net: whatever happens, nothing stays offset.
  setTimeout(function () {
    document.querySelectorAll('.reveal').forEach(function (el) {
      el.classList.add('is-visible');
      pin(el);
    });
    items = [];
  }, 4000);
})();

// Same settling guarantee for the hero/page-hero entrance animations.
(function () {
  var animated = document.querySelectorAll(
    '.hero .eyebrow, .hero h1, .hero__copy > p, .hero__actions, .hero__points, .hero__decor, .page-hero h1, .page-hero p'
  );
  if (!animated.length) return;
  setTimeout(function () {
    animated.forEach(function (el) {
      el.style.animation = 'none';
      el.style.transform = 'none';
    });
  }, 2200);
})();

// Stat counter count-up. The final value is already in the HTML, so if
// anything fails the correct number is simply shown; a timeout also
// force-restores the exact original text.
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var stats = document.querySelectorAll('.stat__value');
  if (!stats.length) return;

  stats.forEach(function (el) {
    var original = el.textContent.trim();
    var match = original.match(/^([^\d]*)([\d.,]+)(.*)$/);
    if (!match) return;
    var target = parseFloat(match[2].replace(/,/g, ''));
    if (!isFinite(target)) return;
    var decimals = (match[2].split('.')[1] || '').length;
    var started = false;

    function format(value) {
      var text = value.toFixed(decimals);
      if (match[2].indexOf(',') !== -1) {
        text = text.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }
      return match[1] + text + match[3];
    }

    function run() {
      if (started) return;
      started = true;
      var start = null;
      var duration = 1300;
      function frame(now) {
        if (start === null) start = now;
        var progress = Math.min((now - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = format(target * eased);
        if (progress < 1) window.requestAnimationFrame(frame);
        else el.textContent = original;
      }
      window.requestAnimationFrame(frame);
      // Safety: exact original text no matter what
      setTimeout(function () { el.textContent = original; }, duration + 500);
    }

    function checkStart() {
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        run();
        window.removeEventListener('scroll', checkStart);
      }
    }
    window.addEventListener('scroll', checkStart, { passive: true });
    checkStart();
    setTimeout(run, 3000);
  });
})();
